import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Topics from "Data/Topics";

export class Rooster extends SceneSpine {
	constructor() {
		super("rooster");
		this.spine.position.y = -100;
		this.spine.state.timeScale = 2;
		this.interactive = true;
		this.buttonMode = true;
		this.accessible = true;
		this.addListener(HLF.Input.Events.POINTER_TAP, () => {
			PubSub.publishSync("rooster clicked", this);
			this.interactive = false;
			// trigger spine animation
			new TimelineLite()
				.call(() => this.Crow(), undefined, undefined, 0)
				.call(() => {
					PubSub.publishSync("rooster animationcomplete", this);
					this.interactive = true;
				}, undefined, undefined, 2)
			;
		});
	}

	public Crow() {
		this.playAnimation("crowing", false);
		HLF.Application.instance.audio.play("RoosterCall", undefined, false, HLF.AudioCategory.SFX);
	}
}